
import { Component,ViewChild, ElementRef } from '@angular/core';


@Component({
  selector: 'ngx-qr-code',
  template: '<canvas #qrCanvas width="256" height="256" style="display: none;"></canvas>',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent  {
  @ViewChild('qrCanvas', { static: true }) qrCanvas!: ElementRef<HTMLCanvasElement>;

  // Function to generate the QR code and return the base64 image string
  generateQrCodeImage(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const canvas = this.qrCanvas.nativeElement;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject('Failed to get canvas context');
        return;
      }

      // Generate QR code using QRCode.js
      (window as any).QRCode.toCanvas(canvas, url, { width: 256 }, (error: any) => {
        if (error) {
          reject('QR Code generation error: ' + error);
        } else {
          // Convert canvas to base64 image data and return it
          const qrImage = canvas.toDataURL(); // Base64 image data
          resolve(qrImage);
        }
      });
    });
  }
}
